<script lang="ts" setup>
import { defineProps, toRef, computed, inject } from 'vue'
import { useField } from 'vee-validate'
import { DetectedIDSKComponents } from '/@src/utils/zoppm/detectIDKSComponentName'
import { ZoppmSchemeTransformer } from '/@src/utils/zoppm'
import { useSteps } from '/@src/composable/useSteps'

export interface ValidationWrapperProps {
  name: string
  value?: unknown
  component?: DetectedIDSKComponents
  isTrimmed?: boolean
}

const props = withDefaults(defineProps<ValidationWrapperProps>(), {
  component: undefined,
  value: undefined,
})

const name = toRef(props, 'name')
const isReadOnly = inject<boolean>('isReadOnly')
const { activeStepNumber } = useSteps()

const componentName = computed(() =>
  props.component
    ? ZoppmSchemeTransformer.getComponentDefinition(props.component)
    : undefined
)

const {
  value: inputValue,
  errorMessage,
  handleBlur,
  setValue,
  meta,
} = useField(name, undefined, {
  initialValue: props.value,
})
</script>

<template>
  <component
    :is="componentName"
    v-if="props.isTrimmed && componentName"
    :key="isReadOnly && activeStepNumber"
    v-bind="props"
    :model-value="inputValue"
    :error-message="meta.touched ? errorMessage : undefined"
    @update:model-value="(v) => setValue(v?.trim() || v)"
    @blur="handleBlur"
  />
  <component
    :is="componentName"
    v-else-if="componentName"
    :key="isReadOnly && activeStepNumber"
    v-bind="props"
    v-model="inputValue"
    :error-message="meta.touched ? errorMessage : undefined"
    @blur="handleBlur"
  />
</template>

<style scoped></style>
